module.exports = __webpack_public_path__ + "static/banner9-1feba93ab730d8baa42faee701d3621f.jpeg";